
import { Component, Prop, Vue } from "vue-property-decorator";

enum Direction {
  Horizontal = "horizontal",
  Vertical = "vertical",
}

@Component
export default class GsDivider extends Vue {
  // @Prop() direction: Direction = Direction.Horizontal;
  @Prop({ default: "1px" }) stroke: number;
  @Prop({ default: "#aaa" }) color: string;
  @Prop({ default: "0" }) margin: string;
}
